// src/components/HomeRedirect.js
// Used as the index route inside the business Layout — sends someone to
// their most relevant page (Web Development for Tech Partners, Dashboard
// for Zilo customers) instead of always assuming Dashboard.
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { defaultLandingRoute } from "../lib/businessType";

export default function HomeRedirect() {
  const { businessProfile } = useAuth();
  return <Navigate to={defaultLandingRoute()} replace />;
}
